export default __webpack_public_path__ + "static/media/maitime-industry.16b84d9d.jpg";